import React, { useEffect, useContext, useRef } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-fixedcolumns";
import { useSelector } from "react-redux";
import FilterContext from "../../utils/FilterContext";
import AxiosInstance from "../../utils/AxiosInstance";


const DailyReportTableTwelve = ({ id, mainHeader, statename, centerType, selectedColumnType, responseData }) => {

    const { filters } = useContext(FilterContext);
    const datatableRef = useRef(null); // store DataTable instance
    const filtersRef = useRef(filters);
    const isInitialMount = useRef(true); // Track initial mount
    const centerTypeArray = Array.from(new Set(centerType.split(",").map((item) => item.trim())));

    console.log("Initial Filterred Columns:", selectedColumnType);
    let filteredCols = [];

    useEffect(() => {
        filtersRef.current = filters;

    }, [ filters ]);

    // Reload table data when filters change, but skip on initial mount
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false; // Mark initial mount as complete
        } else {
            const timeout = setTimeout(() => {
                if (datatableRef.current) {
                    console.log("Reloading table due to filter change:", filters);
                    datatableRef.current.ajax.reload();
                }
            }, 300); // Wait 300ms to avoid excessive reloads
            return () => clearTimeout(timeout); // Cleanup previous debounce
        }
    }, [ filters ]);




    useEffect(() => {


        filteredCols = mainHeader.slice();
        // console.log("Filtered Columns:", filteredCols);
        const tableElement = $(`#dataTable${id}`);
        const thead = $("<thead>");
        const headerRow1 = $("<tr>");

        let rowText1 = '';


        // console.log("Creating header with columns:", filteredCols);

        filteredCols.forEach((col) => {
            if (col.rowSpan) {
                headerRow1.append(`<th rowspan="1">${col.label}</th>`);
                rowText1 += `${col.label}`;
            }
        });
        thead.append(headerRow1);

        tableElement.find("thead").remove(); // clear any existing header
        console.log("header", thead.html());
        tableElement.append(thead);
        const table = $(`#dataTable${id}`).DataTable({
            processing: true,
            serverSide: false,
            paging: true,
            searching: true,
            lengthChange: true,
            order: [ [ 0, 'asc' ] ], // Default sorting by first column (srNo)
            columnDefs: [
                { orderable: true, targets: 0 }, // Only first column is orderable
                // All other columns are not orderable
            ],


            // data: responseData || [],
            columns: filteredCols.map((col) => {
                if (col.rowSpan) {
                    return { data: col.key, title: col.label };
                }
                return null;
            }).flat().filter(Boolean),

            autoWidth: true,
            data: responseData // ✅ Insert your data here


        });

        datatableRef.current = table;

        return () => {
            table.destroy();
            $(`#dataTable${id}`).empty();
            datatableRef.current = null;
        };
    }, [ id, mainHeader, statename, selectedColumnType ]);



    return <>
        <div className="card basic-data-table cursor-pointer">
            <div className="card-body p-2 pt-20">
                <table
                    className="table table-sm table-bordered table-hover small custom_table"
                    id={`dataTable${id}`}
                    data-page-length={10}
                >
                    <thead>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </div>
    </>
};

export default DailyReportTableTwelve;


// ✅ Updated footerCallback to calculate totals
